import clsx from "classnames";
import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import classes from "./styles.module.scss";
import { PromoItem, Title } from "@/ui";
import { employer_page_helper } from "@/helpers/employer_page_helper";
import { useEmployerPageFilters } from "@/hooks/useEmployerPageFilters";

export default function EmployerPromoSection({
  sectionId,
  className,
  bgColor,
  title,
  titleColor,
  showFilters = false,
  md = 3,
  buttonText,
  buttonVariant,
}) {
  const allFilters = useEmployerPageFilters();
  const allEmployers = employer_page_helper.fetch({ filter: (i) => i.parent.id === null });

  const [activeFilter, setActiveFilter] = useState("All");

  const filteredItems =
    activeFilter === "All" ? allEmployers : allEmployers.filter((item) => item.filter?.includes(activeFilter));

  return (
    <div id={sectionId} className={clsx(className, bgColor, classes.section)}>
      <Container className="mw-xxl">
        <Title className={titleColor} title={title} />

        {showFilters && allFilters.length > 0 && (
          <div className={clsx(classes.buttonTabs, "d-flex flex-wrap gap-2 justify-content-start mb-4")}>
            <button
              key="All"
              type="button"
              className={clsx("btn", activeFilter === "All" ? "btn-primary" : "btn-tertiary")}
              onClick={() => setActiveFilter("All")}
            >
              All
            </button>
            {allFilters.map(({ filter, id }) => (
              <button
                key={id}
                type="button"
                className={clsx("btn", id === activeFilter ? "btn-primary" : "btn-tertiary")}
                onClick={() => setActiveFilter(id)}
              >
                {filter}
              </button>
            ))}
          </div>
        )}

        <Row>
          {filteredItems.length > 0 ? (
            <Row>
              {filteredItems.map((item, k) => (
                <Col key={item.id || k} xs={12} md={md} className="mb-4 mb-md-5">
                  <PromoItem
                    className="h-100"
                    title={item.title}
                    description={item.description || item.body}
                    img={item.card_image}
                    href={`/great-places-to-work/${item.url_slug}`}
                    cta={{
                      label: buttonText,
                      href: `/great-places-to-work/${item.url_slug}`,
                      variant: buttonVariant,
                    }}
                    featured={item.featured}
                    external={false}
                  />
                </Col>
              ))}
            </Row>
          ) : (
            <div className="text-center py-5">
              <p className="text-muted mb-0">No employers found for this filter.</p>
            </div>
          )}
        </Row>
      </Container>
    </div>
  );
}
